import moment from 'moment';
import { apiSlice } from '../../app/services/apiSlice';

const CANDIDATES = 'candidates/';
const INTERVIEWS = '/interviews/';
const JOBS ='jobs/'

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllCandidates: builder.query({
      query: (params) => ({
        url: `${CANDIDATES}list`,
        params,
      }),
    }),
    candidatesBulkEmail: builder.mutation({
      query: (params) => ({
        url: `${CANDIDATES}mail`,
        method: 'POST',
        body: params,
      }),
    }),
    applicationsBulkEmail: builder.mutation({
      query: (params) => ({
        url: `applications/mail`,
        method: 'POST',
        body: params,
      }),
    }),
    getPurchasedCandidates: builder.query({
      query: (params) => ({
        url: `cvlib/purchased/candidates`,
        params,
      }),
    }),
    addNewCandidates: builder.mutation({
      query: (data) => ({
        url: `${CANDIDATES}data-base`,
        method: 'POST',
        body: {
          ...data.candData,
        },
      }),
    }),
    getAllCvsFromLibrary: builder.mutation({
      query: (data) => ({
        url: `cvlib/candidates${data.jobId ? '' : `/search`}`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    unLockCv: builder.mutation({
      query: (data) => ({
        url: `cvlib/candidate`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    editCandidate: builder.mutation({
      query: (data) => ({
        url: `${CANDIDATES}${data.candidateId}`,
        method: 'PUT',
        body: {
          ...data.candidateInfo,
        },
      }),
    }),
    deleteCandidate: builder.mutation({
      query: (id) => ({
        url: `${CANDIDATES}${id}`,
        method: 'DELETE',
      }),
    }),
    getSingleCandidateById: builder.query({
      query: (id) => `${CANDIDATES}${id}`,
    }),
    getSingleCVById: builder.mutation({
      query: (id) => `cvlib/candidate/${id}`,
    }),
    getCandidateDocuments: builder.query({
      query: (id) => `${CANDIDATES}${id}/documents`,
    }),
    uploadCandidateFile: builder.mutation({
      query: (data) => ({
        url: `${CANDIDATES}${data?.candidateId}/document`,
        method: 'POST',
        body: { ...data },
      }),
    }),

    assignToJob: builder.mutation({
      query: (data) => ({
        url: `${CANDIDATES}${data?.candidateId}/assign`,
        method: 'POST',
        body: { ...data },
      }),
    }),
    assignAppToJob: builder.mutation({
      query: (data) => ({
        url: `applications/${data?.existingAppId}/assign`,
        method: 'POST',
        body: { ...data },
      }),
    }),
    getCandidateApplication: builder.mutation({
      query: (data) => ({
        url: `${CANDIDATES}${data?.candidateId}`,
        method: 'GET',
      }),

      transformResponse: (responseData) => {
        responseData.options = responseData?.applications?.map((cat) => ({
          ...cat,
          title: cat.id,
          value: cat.job.title,
        }));
        return responseData || {};
      },
    }),
    getJobApplicationCandidates: builder.mutation({
      query: (data) => ({
        url: `${INTERVIEWS}job`,
        method: 'GET',
        params: data,
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.job?.applications?.map((cat) => ({
          ...cat,
          title: `${cat?.candidate?.firstName} ${cat?.candidate?.lastName}`,
          value: cat.id,
          name:`${cat?.candidate?.firstName} ${cat?.candidate?.lastName}`,
        }));
        return responseData || {};
      },
    }),
    getJobPositions: builder.mutation({
      query: (data) => ({
        url: `${JOBS}${data?.jobId}/positions`,
        method: 'GET',
        params: {...data, statusId:2, jobOffer: true},
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.jobPositions?.map((pos) => ({
          ...pos,
          title: `${moment(pos?.startDate).format('D MMM YYYY')}${pos?.endDate?' - ' + moment(pos?.endDate).format('D MMM YYYY'):''}`,
          value: pos?.id,
        }));
        return responseData || {};
      },
    }),
    uploadBulkResume: builder.mutation({
      query: (params) => ({
        url: `${CANDIDATES}bulk/queue/${params.jobId}${params?.jhpId? `/${params?.jhpId}`:'' }`,
        method: 'POST',
        body: { resume: params.key, source: params.source },
      }),
    }),

    retryBulkResume: builder.mutation({
      query: (id) => ({
        url: `${CANDIDATES}bulk/queue/retry?candidateCvId=${id}`,
        method: 'POST',
      }),
    }),

    getBulkQueue: builder.query({
      query: (jobId) => {
        return {
          url: `${CANDIDATES}bulk/queue${jobId ? '/' + jobId : ''}`,
          method: 'GET',
        };
      },
    }),

    getCandidateCommunication: builder.mutation({
      query: (params) => ({
        url: `${CANDIDATES}${params.candidateId}/messages`,
        params: { ...params },
      }),
    }),
    addQuickFilter: builder.mutation({
      query: (data) => ({
        url: `${CANDIDATES}quick-filter`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    getQuickFilters: builder.query({
      query: (id) => ({
        url: `${CANDIDATES}quick-filter`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useAssignAppToJobMutation,
  useApplicationsBulkEmailMutation,
  useCandidatesBulkEmailMutation,
  useGetAllCandidatesQuery,
  useGetPurchasedCandidatesQuery,
  useAddNewCandidatesMutation,
  useGetAllCvsFromLibraryMutation,
  useUnLockCvMutation,
  useGetSingleCandidateByIdQuery,
  useGetSingleCVByIdMutation,
  useGetCandidateDocumentsQuery,
  useUploadCandidateFileMutation,
  useAssignToJobMutation,
  useEditCandidateMutation,
  useDeleteCandidateMutation,
  useGetCandidateApplicationMutation,
  useGetCandidateCommunicationMutation,
  useGetJobApplicationCandidatesMutation,
  useAddQuickFilterMutation,
  useGetQuickFiltersQuery,
  useUploadBulkResumeMutation,
  useRetryBulkResumeMutation,
  useGetJobPositionsMutation,
  useGetBulkQueueQuery,
} = extendedApiSlice;
